import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';

export const TermsConditions = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-black text-white">
      <div className="container mx-auto px-6 py-12 max-w-4xl">
        <Button
          onClick={() => navigate('/')}
          variant="ghost"
          className="mb-8 text-gray-400 hover:text-white"
        >
          <ArrowLeft className="mr-2 h-4 w-4" />
          Torna alla Home
        </Button>

        <h1 className="text-4xl font-bold mb-8">Termini e Condizioni</h1>
        <p className="text-gray-400 mb-8">Ultimo aggiornamento: {new Date().toLocaleDateString('it-IT')}</p>

        <div className="space-y-8 text-gray-300 leading-relaxed">
          <section>
            <h2 className="text-2xl font-bold text-white mb-4">1. Accettazione dei Termini</h2>
            <p>
              Benvenuto su Digital Performances. Utilizzando il nostro sito web e i nostri servizi, accetti di essere
              vincolato dai presenti Termini e Condizioni. Se non accetti questi termini, ti preghiamo di non utilizzare
              i nostri servizi.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">2. Definizioni</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>"Noi", "Nostro":</strong> Digital Performances</li>
              <li><strong>"Tu", "Utente", "Cliente":</strong> La persona fisica o giuridica che utilizza i nostri servizi</li>
              <li><strong>"Sito":</strong> Il sito web di Digital Performances</li>
              <li><strong>"Servizi":</strong> Tutti i servizi offerti da Digital Performances, inclusi sviluppo software, automazione, consulenza</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">3. Descrizione dei Servizi</h2>
            <p className="mb-4">Digital Performances offre:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Sviluppo di software personalizzato</li>
              <li>Soluzioni di automazione intelligente</li>
              <li>Implementazione di sistemi AI</li>
              <li>Chatbot e assistenti virtuali</li>
              <li>Consulenza digitale</li>
              <li>Supporto e manutenzione continua</li>
            </ul>
            <p className="mt-4">
              I servizi vengono forniti previo accordo contrattuale specifico con il cliente.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">4. Utilizzo del Sito</h2>
            
            <h3 className="text-xl font-semibold text-white mb-3 mt-4">4.1 Licenza d'Uso</h3>
            <p className="mb-4">
              Ti concediamo una licenza limitata, non esclusiva, non trasferibile e revocabile per accedere e utilizzare
              il sito per scopi personali e non commerciali.
            </p>

            <h3 className="text-xl font-semibold text-white mb-3 mt-4">4.2 Restrizioni</h3>
            <p className="mb-4">Non è consentito:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Utilizzare il sito per scopi illegali o non autorizzati</li>
              <li>Tentare di accedere a aree riservate del sito</li>
              <li>Interferire con il funzionamento del sito</li>
              <li>Copiare, modificare, distribuire o vendere contenuti del sito senza autorizzazione</li>
              <li>Utilizzare bot, spider o altri strumenti automatici</li>
              <li>Trasmettere virus, malware o codice dannoso</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">5. Processo di Collaborazione</h2>
            
            <h3 className="text-xl font-semibold text-white mb-3 mt-4">5.1 Richiesta di Preventivo</h3>
            <p>
              La richiesta di informazioni o preventivo non comporta alcun obbligo contrattuale fino alla firma di un
              accordo formale.
            </p>

            <h3 className="text-xl font-semibold text-white mb-3 mt-4">5.2 Contratto di Servizio</h3>
            <p className="mb-4">
              Ogni progetto è regolato da un contratto specifico che definisce:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Ambito del progetto e deliverable</li>
              <li>Tempistiche e milestone</li>
              <li>Costi e modalità di pagamento</li>
              <li>Diritti di proprietà intellettuale</li>
              <li>Garanzie e limitazioni di responsabilità</li>
            </ul>

            <h3 className="text-xl font-semibold text-white mb-3 mt-4">5.3 Abbonamento e Manutenzione</h3>
            <p>
              I servizi di manutenzione continua sono forniti tramite abbonamento mensile. I dettagli specifici
              (durata, costi, servizi inclusi) sono definiti nel contratto individuale.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">6. Pagamenti</h2>
            
            <h3 className="text-xl font-semibold text-white mb-3 mt-4">6.1 Prezzi</h3>
            <p>
              I prezzi sono definiti su base progettuale e comunicati tramite preventivo scritto. I prezzi possono
              variare in base alla complessità del progetto e ai servizi richiesti.
            </p>

            <h3 className="text-xl font-semibold text-white mb-3 mt-4">6.2 Modalità di Pagamento</h3>
            <p className="mb-4">Le modalità di pagamento tipiche includono:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Acconto iniziale (solitamente 30-50% del totale)</li>
              <li>Pagamenti progressivi legati a milestone</li>
              <li>Saldo finale alla consegna</li>
              <li>Abbonamento mensile per servizi continuativi</li>
            </ul>

            <h3 className="text-xl font-semibold text-white mb-3 mt-4">6.3 Ritardi nei Pagamenti</h3>
            <p>
              In caso di ritardo nei pagamenti, ci riserviamo il diritto di sospendere i servizi fino al ricevimento
              del pagamento dovuto.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">7. Proprietà Intellettuale</h2>
            
            <h3 className="text-xl font-semibold text-white mb-3 mt-4">7.1 Contenuti del Sito</h3>
            <p>
              Tutti i contenuti del sito (testi, immagini, loghi, grafica, codice) sono di proprietà di Digital
              Performances o concessi in licenza e sono protetti da copyright e altre leggi sulla proprietà
              intellettuale.
            </p>

            <h3 className="text-xl font-semibold text-white mb-3 mt-4">7.2 Lavori Personalizzati</h3>
            <p>
              I diritti di proprietà intellettuale sui lavori sviluppati su misura sono regolati dal contratto
              specifico. Di norma, il cliente acquisisce i diritti sul software sviluppato dopo il saldo completo del
              pagamento.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">8. Garanzie e Limitazioni di Responsabilità</h2>
            
            <h3 className="text-xl font-semibold text-white mb-3 mt-4">8.1 Garanzia sui Servizi</h3>
            <p>
              Garantiamo che i servizi saranno forniti con competenza e professionalità. Eventuali difetti segnalati
              entro il periodo di garanzia (specificato nel contratto) saranno corretti senza costi aggiuntivi.
            </p>

            <h3 className="text-xl font-semibold text-white mb-3 mt-4">8.2 Esclusioni di Garanzia</h3>
            <p className="mb-4">La garanzia non copre:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Modifiche non autorizzate al software</li>
              <li>Uso improprio o negligente</li>
              <li>Problemi causati da software di terze parti</li>
              <li>Eventi di forza maggiore</li>
            </ul>

            <h3 className="text-xl font-semibold text-white mb-3 mt-4">8.3 Limitazione di Responsabilità</h3>
            <p>
              Nella misura massima consentita dalla legge, Digital Performances non sarà responsabile per danni
              indiretti, incidentali, consequenziali o punitivi derivanti dall'uso dei nostri servizi. La nostra
              responsabilità totale sarà limitata all'importo pagato per il servizio specifico.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">9. Riservatezza</h2>
            <p>
              Entrambe le parti si impegnano a mantenere riservate le informazioni confidenziali scambiate durante la
              collaborazione. Per maggiori dettagli sul trattamento dei dati personali, consulta la nostra{' '}
              <a href="/privacy-policy" className="text-white underline">Privacy Policy</a>.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">10. Risoluzione del Contratto</h2>
            
            <h3 className="text-xl font-semibold text-white mb-3 mt-4">10.1 Risoluzione da parte del Cliente</h3>
            <p>
              Il cliente può risolvere il contratto con preavviso scritto. Le condizioni specifiche di recesso sono
              definite nel contratto individuale.
            </p>

            <h3 className="text-xl font-semibold text-white mb-3 mt-4">10.2 Risoluzione da parte di Digital Performances</h3>
            <p className="mb-4">
              Possiamo risolvere il contratto in caso di:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Mancato pagamento</li>
              <li>Violazione dei termini contrattuali</li>
              <li>Comportamento inappropriato o illegale</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">11. Modifiche ai Termini</h2>
            <p>
              Ci riserviamo il diritto di modificare questi Termini e Condizioni in qualsiasi momento. Le modifiche
              entreranno in vigore al momento della pubblicazione sul sito. L'uso continuato del sito dopo le modifiche
              costituisce accettazione dei nuovi termini.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">12. Legge Applicabile e Giurisdizione</h2>
            <p>
              Questi Termini e Condizioni sono regolati dalla legge italiana. Per qualsiasi controversia derivante da
              questi termini, sarà competente in via esclusiva il Foro di [Inserire città], Italia.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">13. Divisibilità</h2>
            <p>
              Se una qualsiasi disposizione di questi Termini viene ritenuta invalida o inapplicabile, tale
              disposizione sarà eliminata o limitata nella misura minima necessaria, e le restanti disposizioni
              continueranno ad avere piena efficacia.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">14. Comunicazioni</h2>
            <p className="mb-4">
              Tutte le comunicazioni ufficiali relative ai presenti Termini devono essere inviate a:
            </p>
            <p>
              <strong>Digital Performances</strong><br />
              Email: <a href="mailto:info@digitalperformances.it" className="text-white underline">info@digitalperformances.it</a><br />
              Email assistenza: <a href="mailto:assistenza@digitalperformances.it" className="text-white underline">assistenza@digitalperformances.it</a><br />
              WhatsApp: <a href="https://wa.me/393793460226" target="_blank" rel="noopener noreferrer" className="text-white underline">+39 379 346 0226</a>
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">15. Domande</h2>
            <p>
              Per domande o chiarimenti su questi Termini e Condizioni, contattaci all'indirizzo{' '}
              <a href="mailto:info@digitalperformances.it" className="text-white underline">
                info@digitalperformances.it
              </a> o via WhatsApp al{' '}
              <a href="https://wa.me/393793460226" target="_blank" rel="noopener noreferrer" className="text-white underline">
                +39 379 346 0226
              </a>.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};
